<template>
  <!-- style="height: 0px; overflow: hidden;" -->
  <div style="height: 0px; overflow: hidden;">
    <div class="pdf-row" id="pdfTest">
      <div class="top">费用支出审批单</div>
      <barcode 
        class="barcode" 
        :value="info.eventId" 
        width="1" 
        height="30" 
        background="transparent"
        :displayValue="true"
        fontSize="14"
      ></barcode>
      
      <div class="date">申请日期：{{this.info.createTime}}</div>
      <el-row class="table-row">
        <el-col :span="4" class="">申请编号</el-col>
        <el-col :span="20" class="border-left">{{this.info.eventId || '-'}}</el-col>
        <el-col :span="4" class=" border-top">收款单位</el-col>
        <el-col :span="20" class="border-left border-top ">{{this.info.receiver || '-'}}</el-col>
        <el-col :span="4" class="border-top">付款内容</el-col>
        <el-col :span="6" class="border-left border-top">{{this.info.feeType}}</el-col>
        <el-col :span="7" class="border-top">付款方式：{{this.info.paymentMethod === 0 ? '现金' : '转账'}}</el-col>
        <el-col :span="7" class="border-left border-top  ">附件：{{this.info.invoiceUrl}}</el-col>
        
        <el-col :span="10" class="border-top">银行账号：{{this.info.bankAccount}}</el-col>
        <el-col :span="14" class="border-left border-top  ">开户行：{{this.info.bank}}</el-col>
        <el-col :span="24" class="border-top ">本次付款情况说明：{{this.info.invoiceDescription}}</el-col>
        <el-col :span="24" class="border-top ">
          <div>合同执行情况：累计已付<span class="bottom_line">{{this.info.payedTotal}}</span>元，本次支付<span class="bottom_line">{{this.info.payedThisTime}}</span>元，剩余未付<span class="bottom_line">{{this.info.payedLeft}}</span>元。</div>
          <div>附件：（  &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;    ）张（其中： &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;     <el-checkbox/> 发票   &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;       <   &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;     >  张）</div>
          <div><el-checkbox v-model="checked"/> 合同编号（编号： &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.info.contractNumber || '                         '}} &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;）期限（ &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.info.contractTerm || '                         '}} &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;）</div>
          <div><el-checkbox style="margin: 0;"/> 对上请示（编号：     &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;                        ）<el-checkbox/> 会议纪要（编号：       &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;                           ）</div>
          <div><el-checkbox/> 其他（         &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;                                               ）</div>
        </el-col>
        <el-row>
          <el-col :span="4" class="amount border-top"><div>金额（大写）</div></el-col>
        <el-col :span="12" class="amount-value border-left border-top" style="padding-left: 10px"> {{getMoneyFormat || '-'}}</el-col>
        <el-col :span="8" style="text-align: right; padding-right: 10px" class="amount-value border-left  border-top">{{getToLocaleString}}元</el-col>
        </el-row>
        <el-col :span="4"  class="amount border-top"><div>所属公司</div></el-col>
        <el-col :span="20" class="amount-value border-left border-top ">{{this.info.companyName}}</el-col>
        <el-col :span="4" class="amount border-top"><div>申请部门</div></el-col>
        <el-col :span="8" class="amount-value border-left border-top"> {{this.info.deptName}} </el-col>
        <el-col :span="4" class="amount border-left border-top"><div>经办人</div></el-col>
        <el-col :span="8" class="amount-value border-left border-top "> {{this.info.applyUser}} </el-col>

        <el-col v-for="(item,index) in auditProcessEntityList" :key="index" class="border-top "  style="padding:0; display: flex;">
          <!-- :style="{height: approvalHeight + 'px', padding:0}" -->
          <el-col :span="12"  ref="approvalLeft"  style="padding:0;display: flex;align-items: center;">
            <el-col :span="8" class="amount" style="padding:0"><div>{{(item.status == 20 || item.status == 21) ? '提交人：' : '审核人：'}}</div></el-col>
            <el-col :span="16" class="amount-value border-left" style="display: flex;align-items: center;height:100%"> {{item.auditPerson}}</el-col>
          </el-col>
          <el-col :span="12" class="border-left" ref="approvalRight"  style="padding:0;display: flex;align-items: center;padding:0">
            <el-col :span="8" class="amount" v-if="!([20, 21].includes(item.status))"><div>审核意见/时间：</div></el-col>
            <el-col :span="16" class="border-left amount-value" v-if="!([20, 21].includes(item.status))">
                <div> 时间：{{item.createTime}}</div>
                <div style="word-break:break-word"> 意见：{{item.remark }}</div>
            </el-col>
            <el-col :span="8" class="amount" v-if="[20, 21].includes(item.status)"><div>提交时间：</div></el-col>
            <el-col :span="16" class="border-left" v-if="[20, 21].includes(item.status)">
                <div> 时间：{{item.createTime}}</div>
            </el-col>
          </el-col>
        </el-col>
        <!-- <el-col :span="4" class="amount border-left border-top">
          <div>部门主管</div>
          <div>意   见</div>
        </el-col>
        <el-col :span="8" class="amount-value border-left border-top"><pre> </pre></el-col>
        <el-col :span="4" class="amount border-left border-top">
          <div>行政办</div>
          <div>意  见</div>
        </el-col>
        <el-col :span="8" class="amount-value border-left border-top "><pre> </pre></el-col>
        <el-col :span="4" class="amount border-left border-top">
          <div>分管领导</div>
          <div>意   见</div>
        </el-col>
        <el-col :span="8" class="amount-value border-left border-top"><pre> </pre></el-col>
        <el-col :span="4" class="amount border-left border-top">
          <div>财务部</div>
          <div>意  见</div>
        </el-col>
        <el-col :span="8" class="amount-value border-left border-top "><pre> </pre></el-col>
        <el-col :span="4" class="amount border-left border-top">
          <div>主要领导</div>
          <div>意   见</div>
        </el-col> -->
        <!-- <el-col :span="20" class="amount-value border-left border-top "><pre> </pre></el-col> -->
        <el-col :span="24" class="border-top" style="height: 100px">备注：</el-col>
      </el-row>
      <div style="font-size: 16px; padding: 20px 50px;">会议纪要编号由行政办填写，请示报告填写编号</div>
    </div>
  </div>
</template>
<script>
import { cnMoneyFormat, htmlToPdf } from '@/utils/util'
import { getApplyDetail } from '@/api/compApplyReimbursement'
export default {
  data () {
    return {
      checked: true,
      info: {
        receiver: '',
        feeType: '',
        feeAmount: 0,
        invoiceUrl: 0,
        paymentMethod: '',
        invoiceDescription: '',
        contractRelFlag: '',
        contractName: '',
        contractTerm: '',
        contractNumber: '',
        applyUser: '',
        deptName: '',
        companyName: '',
        createTime: '',
        payedTotal: '',
        payedThisTime: '',
        payedLeft: '',
        eventId: '',
        bankAccount: '',
        bank: '',
        roleName: ''
      },
      approvalHeight: 0,
      auditProcessEntityList: [
        {
          auditPerson: '姜旭',
          createTime: '2022-09-10'
        }
      ],
    }
  },
  mounted() {
    console.log(this.$refs.approvalRight.$el);
    console.log(this.$refs.approvalRight[0].$el.clientHeight);
  },
  methods: {
    async getDetails (id, callback) {
      const res = await getApplyDetail({ id })
      const { code, result } = res
      if (code !== 0) {
        callback && callback()
        return
      }
      console.log(res);
      this.info = {
        receiver: result.receiver,
        eventId: result.eventId,
        bankAccount: result.bankAccount,
        bank: result.bank,
        feeType: result.feeType,
        feeAmount: result.feeAmount,
        invoiceUrl: (result.invoiceUrl || '').split(',').length,
        paymentMethod: result.paymentMethod,
        invoiceDescription: result.invoiceDescription,
        contractRelFlag: result.contractRelFlag,
        contractName: result.contractName,
        contractTerm: result.contractTerm,
        contractNumber: result.contractNumber,
        createTime: (result.createTime || '').substring(0, 10),
        applyUser: result.applyUser,
        payedTotal: result.payedTotal,
        payedThisTime: result.payedThisTime,
        payedLeft: result.payedLeft,
        roleName: result.applyUserInfo.roleName,
        deptName: result.deptName,
        companyName: result?.companyName || '-',
      }
      this.auditProcessEntityList = result.auditProcessEntityList
      if (result.contractRelFlag === 0) {
        this.checked = false
      }
      this.approvalHeight = this.$refs.approvalRight[0].$el.clientHeight
      if (result.contractRelFlag === 1) {
        this.checked = true
      }
     setTimeout(() => {
      this.$nextTick(() => {
        htmlToPdf('#pdfTest', '费用支出审批单', () => {
          callback && callback()
        })
      })
     }, 1000);
    },
    getDate() {
      // 创建一个Date对象，默认为当前日期和时间  
      var now = new Date();  
        
        // 获取年份  
        var year = now.getFullYear();  
          
        // 获取月份（注意：月份是从0开始的，所以要+1）  
        var month = now.getMonth() + 1;  
          
        // 获取日期  
        var date = now.getDate();  
          
        // 获取小时（24小时制）  
        var hour = now.getHours();  
          
        // 获取分钟  
        var minute = now.getMinutes();  
          
        // 获取秒  
        var second = now.getSeconds();  
          
        // 为了确保月份、日期、小时、分钟和秒都是两位数，使用字符串填充方法  
        month = month < 10 ? '0' + month : month;  
        date = date < 10 ? '0' + date : date;  
        hour = hour < 10 ? '0' + hour : hour;  
        minute = minute < 10 ? '0' + minute : minute;  
        second = second < 10 ? '0' + second : second;  
        return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    }
  },
  computed: {
    getMoneyFormat () {
      return cnMoneyFormat(this.info.feeAmount)
    },
    getToLocaleString () {
      const options = {
        style: 'currency',
        currency: 'CNY',
      };
      return (this.info.feeAmount).toLocaleString('zh-CN', options)
    }
  }
}
</script>
<style lang="scss" scoped>
.pdf-row {
  width: 1050px;
  padding: 40px 20px;
  padding-left: 60px;
  padding-right: 60px;
  padding-top: 100px;
  box-sizing: border-box;
  color: #000;
  font-weight: bold;
  position: relative;
  .top {
    height: 100px;
    text-align: center;
    font-size: 25px;
    line-height: 100px;
    font-weight: bold;
    background-image: url('~@/assets/images/gateway/logo.jpg');
    background-repeat: no-repeat;
    background-size: 100px 100px;
  }
  .barcode{
      position: absolute;
      right: 55px;
      top: 40px;
      bottom: 0;
    }
  .date {
    text-align: right;
    font-size: 20px;
  }
  .bottom_line{
    padding: 0 30px;
    border-bottom: 1px solid #000;
  }
  .table-row {
    border: 1px solid #000;
    /deep/ .el-col {
      padding: 0px 10px;
      box-sizing: border-box;
      line-height: 45px;
      font-size: 16px;
    }
    .amount {
      text-align: center;
      // align-items: center;
      // line-height: normal;
      display: flex;
      flex-wrap:wrap;
      align-items: center;
      // min-height: 86px;
      box-sizing: border-box;
      // padding: 20px 0;
      div {
        width: 100%;
      }
    }
    .amount-value {
      // line-height: 40px;
      font-weight: bold;
      // padding: 20px 0;
    }
    .border-left {
      border-left: 1px solid #000;
    }
    .border-top {
      border-top: 1px solid #000;
    }
    .border-right{
      border-right : 1px solid #000;
    }
    .border-bottom {
      border-bottom: 1px solid #000;
    }
  }
}
</style>